/**
 * Passes the proper config object to the application.
 *
 * Static imports (not a dynamic require) so every environment config is reliably
 * bundled and the selection is deterministic in a production build. The target
 * is chosen at build time by REACT_APP_ENV_TARGET (local | production | staging
 * | demo); unknown/unset falls back to local.
 */
import local from "./local.js";
import production from "./production.js";
import staging from "./staging.js";
import demo from "./demo.js";

const CONFIGS = { local, production, staging, demo };

const target = process.env.REACT_APP_ENV_TARGET;
const config = CONFIGS[target] || local;

export default config;
